module.exports = __webpack_public_path__ + "img/ring_skip_0_0_0.46009404.png";